/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Name_Placeholder_ExampleInputs */



/**
* | output |
* | --- |
* | "e.g. French translators" |
*
* @param {Team_Share_Name_Placeholder_ExampleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_name_placeholder_example = /** @type {((inputs?: Team_Share_Name_Placeholder_ExampleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Name_Placeholder_ExampleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("e.g. French translators")
	if (locale === "de") return /** @type {LocalizedString} */ ("e.g. French translators")
	if (locale === "it") return /** @type {LocalizedString} */ ("e.g. French translators")
	if (locale === "ru") return /** @type {LocalizedString} */ ("e.g. French translators")
	if (locale === "es") return /** @type {LocalizedString} */ ("e.g. French translators")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("e.g. French translators")
	if (locale === "ja") return /** @type {LocalizedString} */ ("e.g. French translators")
	if (locale === "hi") return /** @type {LocalizedString} */ ("e.g. French translators")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("e.g. French translators")
	return /** @type {LocalizedString} */ ("e.g. French translators")
});